var _g, _path, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mask Group"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Union",
    filter: "url(#filter0_d_262_3998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5439 7.23177C14.7321 7.23276 15.8887 6.84891 16.8405 6.13768L18.4642 4.9245C19.0706 4.49977 19.878 4.49978 20.4844 4.9245L22.2126 6.17782C23.1456 6.85448 24.2677 7.22091 25.4203 7.22536L26.7942 7.23066C28.1555 7.23066 29.2591 8.3342 29.2591 9.69548C29.2591 10.9372 29.8085 12.1153 30.7599 12.9133L30.8189 12.9628C30.9386 13.0632 31.0077 13.2113 31.0077 13.3675V27.3125C31.0077 28.2849 30.2195 29.0731 29.2471 29.0731H9.76059C8.78831 29.0731 8 28.2849 8 27.3125L8.00086 13.3675C8.00086 13.2113 8.06998 13.0632 8.18947 12.9628L8.24735 12.9143C9.19895 12.116 9.74855 10.9376 9.74855 9.69548C9.74855 8.3342 10.852 7.23066 12.2134 7.23066L13.5439 7.23177Z",
    fill: "#960808",
    fillOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_262_3998",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 4,
    width: 24,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    d: "M15.0226 7.23043L18.4937 4.31855C19.1001 3.89382 19.9075 3.89382 20.5139 4.31855L23.9853 7.23043H26.7942C28.1555 7.23043 29.2591 8.33397 29.2591 9.69525V11.6542L30.8189 12.9626C30.9386 13.063 31.0077 13.2111 31.0077 13.3673V27.3123C31.0077 28.2847 30.2195 29.0729 29.2471 29.0729H9.76059C8.78831 29.0729 8 28.2847 8 27.3123L8.00086 13.3672C8.00086 13.2111 8.06998 13.063 8.18947 12.9626L9.74855 11.6547V9.69525C9.74855 8.33397 10.852 7.23043 12.2134 7.23043H15.0226Z",
    fill: "#EBE9FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_262_3998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 37210"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    d: "M17.9315 5.05824L8.78187 12.4868C8.28779 12.8879 8.00086 13.4904 8.00083 14.1268L8.00006 27.3122C8.00006 28.2846 8.7883 29.0728 9.76065 29.0728H29.2472C30.2195 29.0728 31.0077 28.2846 31.0077 27.3122V14.1294C31.0077 13.4915 30.7195 12.8878 30.2236 12.4867L21.0351 5.05531C20.1297 4.32309 18.8354 4.32431 17.9315 5.05824Z",
    fill: "#FFBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4309",
    d: "M26.7943 7.23047C28.1556 7.23047 29.2592 8.33401 29.2592 9.69529L29.2592 28.7208C29.2592 28.9153 29.1015 29.0729 28.907 29.0729L10.1007 29.0729C9.90627 29.0729 9.74863 28.9153 9.74863 28.7208L9.74863 9.69529C9.74863 8.334 10.8522 7.23047 12.2134 7.23047L26.7943 7.23047Z",
    fill: "#F9F9FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 37213"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4313",
    x: 12.406,
    y: 15.708,
    width: 11.1238,
    height: 1.60637,
    rx: 0.803183,
    fill: "#FFBBBB"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4312",
    x: 12.4059,
    y: 10.2437,
    width: 11.015,
    height: 1.60637,
    rx: 0.803183,
    fill: "#FFBBBB"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4313_2",
    x: 12.406,
    y: 12.9756,
    width: 8.35309,
    height: 1.60637,
    rx: 0.803183,
    fill: "#FFBBBB"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 290",
    d: "M16.8608 21.0452L7.89478 13.8096L7.95701 28.3517L16.8608 21.0452Z",
    fill: "#EEAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 291",
    d: "M22.1929 21.1726L31.2758 13.9141L31.1498 27.745L22.1929 21.1726Z",
    fill: "#EEAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 285",
    d: "M4.19577 28.6329L17.5181 19.3016C18.7309 18.4522 20.3455 18.4522 21.5583 19.3016L37.6241 30.5545C37.906 30.752 37.7663 31.195 37.4221 31.195L5.0038 31.195C3.62693 31.195 3.06802 29.4228 4.19577 28.6329Z",
    fill: "#DE8D8D"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_262_3998",
    x: 0.730323,
    y: 0.329676,
    width: 37.547,
    height: 39.0066,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.9934
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.63484
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.729167 0 0 0 0 0.0486111 0 0 0 0 0.0486111 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_262_3998"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_262_3998",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7ee1ff86decb573ed2125fd833e07d00.svg";
export { ForwardRef as ReactComponent };